const BASE = '';

const api = {
  get token() { return localStorage.getItem('dlp_token'); },
  setToken(t) { if (t) localStorage.setItem('dlp_token', t); else localStorage.removeItem('dlp_token'); },

  async request(method, url, body) {
    const headers = { 'Content-Type': 'application/json' };
    if (this.token) headers['Authorization'] = 'Bearer ' + this.token;
    const opts = { method, headers };
    if (body) opts.body = JSON.stringify(body);
    const res = await fetch(BASE + url, opts);
    if (res.status === 401 && this.token && !url.startsWith('/api/auth/')) {
      window.dispatchEvent(new CustomEvent('auth-expired'));
      throw new Error('Session expired — please sign in again');
    }
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Request failed');
    return data;
  },

  get(url) { return this.request('GET', url); },
  post(url, body) { return this.request('POST', url, body); },
  put(url, body) { return this.request('PUT', url, body); },
  del(url) { return this.request('DELETE', url); },

  async upload(url, formData) {
    const headers = {};
    if (this.token) headers['Authorization'] = 'Bearer ' + this.token;
    const res = await fetch(BASE + url, { method: 'POST', headers, body: formData });
    if (res.status === 401 && this.token) {
      window.dispatchEvent(new CustomEvent('auth-expired'));
      throw new Error('Session expired — please sign in again');
    }
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Upload failed');
    return data;
  },
};

export { api };
export default api;
